
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.24 13.722L.276 7.672a.96.96 0 010-1.344L6.24.278a.928.928 0 011.326 0 .96.96 0 010 1.345L3.2 6.049h10.848a.95.95 0 110 1.902H3.201l4.366 4.426a.96.96 0 010 1.345.928.928 0 01-1.326 0z","fill":"#000"}})])
          )
        }
      }
    